var swiperMenu;

function MenuSlider() {
	swiperMenu = new Swiper(".js-menu-slider", {
		slidesPerView: "auto",
		slidesOffsetAfter: 80,
		breakpoints: {
			// when window width is >= 992px
			992: {
				allowTouchMove: false,
				slidesOffsetAfter: 0,
			}
		}
	});
}

function ScrollLinksMove() {
	let docTop = $(document).scrollTop();

	$('.js-scroll-link').each(function () {
		let hash = $(this).attr("href");
		let target = $(hash);

		let topDistance = target.position().top - 80;

		if (topDistance <= docTop && topDistance + target.outerHeight() > docTop) {
			$('.js-scroll-link').removeClass("is-active");
			$(this).addClass("is-active");
			if ($(".js-menu-slider").length) {
				let slideIndex = $(this).closest('.swiper-slide').index();

				swiperMenu.slideTo(slideIndex, 1000, false);
			}

		} else {
			$(this).removeClass("is-active");
		}
	});
}

function ScrollLinksClick() {
	$(".js-scroll-link").click(function (e) {
		e.preventDefault();
		e.stopPropagation();

		let hash = $(this).attr("href");
		let target = $(hash);

		$("html, body").animate({
			scrollTop: target.offset().top - 75
		}, 1000, function () {
			$(window).scroll(function () {
				ScrollLinksMove();
			})
		});

		return false;
	});

}

function ScrollLinksActions() {
	MenuSlider();
	ScrollLinksClick();
	ScrollLinksMove();
	
	$(window).scroll(function () {
		ScrollLinksMove();
	});
}

export { ScrollLinksActions };